




























































































































































import { Component, Vue } from 'vue-property-decorator';
import CaravanPlayer from 'caravan-player/src/CaravanPlayer.vue';
import { mod } from '@/scripts/MathTool';

@Component({
  components: {
    CaravanPlayer
  },
})
export default class Home extends Vue {
  public height = window.innerHeight * 5 / 6;
  private colors = ['blue', 'green', 'purple', 'orange'];
  get themeColor(): string {
    return this.$store.state.color;
  }
  public changeColor(): void {
    this.$store.commit('setColor',
      this.colors[mod(this.colors.indexOf(this.themeColor) + 1, this.colors.length)]);
  }
}
